import makeApiRequest from 'src/lib/makeApiRequest';
import { API_URL } from 'src/constants/Endpoints';

export const getEventTicketsData =
  (organisation: string, eventId: number, productId: number) => makeApiRequest({
    method: 'POST',
    url: `${API_URL.eventTickets}?debug=1`,
    organisation,
    data: {
      fields: ['event_tickets.ticket_identifier'],
      filters: {
        and: [
          ['event_tickets.event_id', '=', eventId],
          ['event_tickets.product_id', '=', productId],
          ['event_tickets.status', 'IS_NOT_EQUAL', 'available'],
          ['event_tickets.deleted_at', 'IS_NOT_DEFINE'],
        ],
      },
    },
  });
